import { withDependencies } from '@wix/thunderbolt-ioc'
import type {
	BrowserWindow,
	IPageDidMountHandler,
	IPageDidUnmountHandler,
	Experiments,
	ILogger,
} from '@wix/thunderbolt-symbols'
import { BrowserWindowSymbol, ExperimentsSymbol, LoggerSymbol } from '@wix/thunderbolt-symbols'
import { accessibilityUtils } from './accessibilityUtils'
import { freezeFontSizesOnZoom } from './zoomUtils'

const accessibilityFactory = (
	window: BrowserWindow,
	experiments: Experiments,
	logger: ILogger
): IPageDidMountHandler & IPageDidUnmountHandler => {
	const { addFocusRingAndKeyboardTabbingOnClasses, removeKeyboardTabbingOnClass } = accessibilityUtils(
		window,
		experiments
	)

	// Store cleanup function returned by freezeFontSizesOnZoom
	let cleanupZoomListeners: (() => void) | null = null

	return {
		pageDidMount() {
			window!.addEventListener('keydown', addFocusRingAndKeyboardTabbingOnClasses)
			window!.addEventListener('click', removeKeyboardTabbingOnClass)

			// Handle font freezing on every page mount
			cleanupZoomListeners = freezeFontSizesOnZoom(window, experiments, logger)
		},
		pageDidUnmount() {
			window!.removeEventListener('keydown', addFocusRingAndKeyboardTabbingOnClasses)
			window!.removeEventListener('click', removeKeyboardTabbingOnClass)

			// Clean up zoom listeners to prevent memory leaks
			if (cleanupZoomListeners) {
				cleanupZoomListeners()
				cleanupZoomListeners = null
			}
		},
	}
}

export const Accessibility = withDependencies(
	[BrowserWindowSymbol, ExperimentsSymbol, LoggerSymbol] as const,
	accessibilityFactory
)
